import {
	signin,
	signup,
	verification,
	check,
	logout,
	checkEmail,
	resendCode,
	getProfile,
	setProfile,
	addPhone,
	validatorFileUpload,
	extractId,
	utilityFileUpload,
	verifyPhone,
	registerEvent,
	getTransaction,
	checkout,
	validateId,
	resetPassword,
	changeProfile,
	getResource,
	newPassword,
	registerFastRunner,
	checkId,
	agreeNews,
	setLanguage,
	setupPassword,
	rejectInvitation,
	approveBallot,
	verifyData,
	getMembers,
	getMember,
	sendMail,
	getRegistrations,
	rejectFastRunner,

	fetchUser,
	fetchItems,
	fetchItemsByResource,

	updateMemberData
} from '../api'

function parseLinked(resp) {
	var data = resp.data;
	var linkedBuffer = {};
	Object.keys(data.linked).forEach(function(field){
		if (!linkedBuffer[field]) linkedBuffer[field] = {};
		data.linked[field].forEach(function(d){
			linkedBuffer[field][d.id] = d;
		})
		// console.log(field);
	})
	data.data.forEach(function(d){
		Object.keys(d.links).forEach(function(field){
			Object.assign(d, linkedBuffer[field][d.links[field]]);
		})
	})
	// console.log('Link to parse : ', data, linkedBuffer)
};

export default {
	GETREGISTRATIONS: ({ commit, dispatch, state }, { params }) => {
		return new Promise((resolve, reject) => {
			console.log('GR : ', params);
			getRegistrations(params)
				.then(resp => {
					parseLinked(resp);
					// console.log('resource out : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('E resource : ', err.response);
					reject(err)
				})
		})		
	},

	GETMEMBERS: ({ commit, dispatch, state }, { params }) => {
		return new Promise((resolve, reject) => {
			console.log('GR : ', params);
			getMembers(params)
				.then(resp => {
					console.log('resource out : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('E resource : ', err.response);
					reject(err)
				})
		})		
	},

	GETMEMBER: ({ commit, dispatch, state }, { params }) => {
		return new Promise((resolve, reject) => {
			console.log('GR : ', params);
			getMember(params)
				.then(resp => {
					console.log('resource out : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('E resource : ', err.response);
					reject(err)
				})
		})		
	},
	GETRESOURCE: ({ commit, dispatch, state }, { source, params }) => {
		return new Promise((resolve, reject) => {
			// console.log('GR : ', params);
			getResource(source, params)
				.then(resp => {
					console.log('resource out : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('E resource : ', err.response);
					reject(err)
				})
		})		
	},
	CHECKOUT: ({ commit, dispatch, state }, { data }) => {
		return new Promise((resolve, reject) => {
			checkout(data)
				.then(resp => {
					console.log('checkout : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('E checkout : ', err.response);
					reject(err)
				})
		})		
	},
	VERIFYDATA: ({ commit, dispatch, state }, { fileId }) => {
		return new Promise((resolve, reject) => {
			verifyData(fileId)
				.then(resp => {
					console.log('checkout : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('E checkout : ', err.response);
					reject(err)
				})
		})		
	},
	SIGNUP: ({ commit, dispatch, state }, { data }) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			signup(data)
				.then(resp => {
					console.log('S : ', resp);
					// const token = resp.data.token
					// const user = resp.data.user
					// localStorage.setItem('token', token)
					// axios.defaults.headers.common['Authorization'] = token
					// commit('auth_success', token, user)
					resolve(resp)
				})
				.catch(err => {
					console.log('E : ', err.response);
					// commit('auth_error')
					// localStorage.removeItem('token')
					reject(err)
				})
		})		
	},
	SETPROFILE: ({ commit, dispatch, state }, { data }) => {
		return new Promise((resolve, reject) => {
			setProfile(data)
				.then(resp => {
					console.log('setProfile : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('E setProfile : ', err.response);
					reject(err)
				})
		})		
	},
	SETLANGUAGE: ({ commit, dispatch, state }, { language }) => {
		return new Promise((resolve, reject) => {
			setLanguage(language)
				.then(resp => {
					console.log('setLanguage : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('E setLanguage : ', err.response);
					reject(err)
				})
		})		
	},
	REJECTINVITATION: ({ commit, dispatch, state }, { code }) => {
		return new Promise((resolve, reject) => {
			rejectInvitation(code)
				.then(resp => {
					console.log('rejectInvitation : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('E rejectInvitation : ', err.response);
					reject(err)
				})
		})		
	},
	VALIDATEID: ({ commit, dispatch, state }, { data }) => {
		return new Promise((resolve, reject) => {
			validateId(data)
				.then(resp => {
					console.log('validateId : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('E validateId : ', err.response);
					reject(err)
				})
		})		
	},
	CHECKID: ({ commit, dispatch, state }, { data }) => {
		return new Promise((resolve, reject) => {
			checkId(data)
				.then(resp => {
					// console.log('checkId : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('E checkId : ', err.response);
					reject(err)
				})
		})		
	},
	REGISTEREVENT: ({ commit, dispatch, state }, { data, type }) => {
		console.log('BBBBBBBBBB : ', type)
		return new Promise((resolve, reject) => {
			if (type&&type=='FRQ'){
				registerFastRunner(data)
					.then(resp => {
						console.log('registerEvent : ', resp);
						resolve(resp)
					})
					.catch(err => {
						console.log('E registerEvent : ', err.response);
						reject(err)
					})
			} else {			
				registerEvent(data)
					.then(resp => {
						console.log('registerEvent : ', resp);
						resolve(resp)
					})
					.catch(err => {
						console.log('E registerEvent : ', err.response);
						reject(err)
					})
			}
		})		
	},
	VERIFICATION: ({ commit, dispatch, state }, { data }) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			verification(data)
				.then(resp => {
					console.log('S : ', resp);
					// const token = resp.data.token
					// const user = resp.data.user
					// localStorage.setItem('token', token)
					// axios.defaults.headers.common['Authorization'] = token
					// commit('auth_success', token, user)
					resolve(resp)
				})
				.catch(err => {
					console.log('E : ', err.response);
					// commit('auth_error')
					// localStorage.removeItem('token')
					reject(err)
				})
		})		
	},
	CHECKEMAIL: ({ commit, dispatch, state }, { data }) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			checkEmail(data)
				.then(resp => {
					console.log('Email Checked : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('Email Error : ', err.response);
					reject(err)
				})
		})		
	},
	ADDPHONE: ({ commit, dispatch, state }, { data }) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			addPhone(data)
				.then(resp => {
					console.log('Add phone out : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('Add phone error : ', err.response);
					reject(err)
				})
		})		
	},
	VERIFYPHONE: ({ commit, dispatch, state }, { data }) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			verifyPhone(data)
				.then(resp => {
					console.log('S : ', resp);
					// const token = resp.data.token
					// const user = resp.data.user
					// localStorage.setItem('token', token)
					// axios.defaults.headers.common['Authorization'] = token
					// commit('auth_success', token, user)
					resolve(resp)
				})
				.catch(err => {
					console.log('E : ', err.response);
					// commit('auth_error')
					// localStorage.removeItem('token')
					reject(err)
				})
		})		
	},
	GETTRANSACTION: ({ commit, dispatch, state }, { data }) => {
		return new Promise((resolve, reject) => {
			getTransaction(data)
				.then(resp => {
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
		})		
	},
	RESENDVERIFICATIONEMAIL: ({ commit, dispatch, state }, { data }) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			resendCode(data)
				.then(resp => {
					console.log('Resend verification email : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('Resend Email Error : ', err.response);
					reject(err)
				})
		})		
	},
	CHANGEPROFILE: ({ commit, dispatch, state }, { data }) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			changeProfile(data)
				.then(resp => {
					console.log('change profile : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('change profile error : ', err.response);
					reject(err)
				})
		})		
	},
	APPROVEBALLOT: ({ commit, dispatch, state }, { data }) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			// console.log('BBB : ', data);
			approveBallot(data)
				.then(resp => {
					console.log('approve ballot : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('approval error : ', err.response);
					reject(err)
				})
		})		
	},
	REJECTFRQ: ({ commit, dispatch, state }, { data }) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			// console.log('BBB : ', data);
			rejectFastRunner(data)
				.then(resp => {
					console.log('rejectFastRunner success: ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('rejectFastRunner error : ', err.response);
					reject(err)
				})
		})		
	},
	CHANGEPASSWORD: ({ commit, dispatch, state }, { params, data }) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			newPassword(params, data)
				.then(resp => {
					console.log('change profile : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('change profile error : ', err.response);
					reject(err)
				})
		})		
	},
	UPDATEMEMBERDATA: ({ commit, dispatch, state }, { params, data }) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			updateMemberData(params, data)
				.then(resp => {
					console.log('change profile : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('change profile error : ', err.response);
					reject(err)
				})
		})		
	},
	RESETPASSWORD: ({ commit, dispatch, state }, { data }) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			resetPassword(data)
				.then(resp => {
					console.log('Reset password : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('Reset password error : ', err.response);
					reject(err)
				})
		})		
	},
	SETUPPASSWORD: ({ commit, dispatch, state }, { data }) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			setupPassword(data)
				.then(resp => {
					console.log('setupPassword password : ', resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('setupPassword password error : ', err.response);
					reject(err)
				})
		})		
	},
	SIGNIN: ({ commit, dispatch, state }, { data, userType }) => {
		return new Promise((resolve, reject) => {
			commit('auth_request')
			signin(data, userType)
				.then(resp => {
					const token = resp.data.data
					const user = resp.data.data
					if (localStorage){
						localStorage.setItem('token', token)
					}
					// axios.defaults.headers.common['Authorization'] = token
					commit('auth_success', token, user)
					console.log('Login Response : ', token, user, userType, resp);
					resolve(resp)
				})
				.catch(err => {
					console.log('E : ', err.response);
					commit('auth_error')
					if (localStorage){
						localStorage.removeItem('token')
					}					
					reject(err)
				})
		})		
	},
	LOGOUT: ({ commit, dispatch, state }) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			logout()
				.then(resp => {
					console.log('S : ', resp);
					if (localStorage){
						localStorage.removeItem('token')
					}
					commit('logout')
					resolve(resp)
				})
				.catch(err => {
					console.log('E : ', err.response);
					reject(err)
				})
		})		
	},
	CHECK: ({ commit, dispatch, state }) => {
		console.log('STAAAAAATE : ', state.isAdmin);
		var userType = 'member';
		if (state.isAdmin){
			userType = 'admin';
		}
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			// console.log('ZZZZZ : ', userType);
			check(userType)
				.then(resp => {
					console.log('S : ', resp);
					// const token = resp.data.data.key
					const user = resp.data.data
					// if (localStorage){
					// 	localStorage.setItem('token', token)
					// }
					// axios.defaults.headers.common['Authorization'] = token
					commit('auth_success', user)
					resolve(resp)
				})
				.catch(err => {
					// console.log('E : ', err.response);
					reject(err)
				})
		})		
	},
	AGREENEWS: ({ commit, dispatch, state },{data}) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			agreeNews(data)
				.then(resp => {
					// console.log('S : ', resp);
					resolve(resp)
				})
				.catch(err => {
					// console.log('E : ', err.response);
					reject(err)
				})
		})		
	},
	SENDMAIL: ({ commit, dispatch, state },{data,key}) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			console.log('AAAA : ', data);
			sendMail(data,key)
				.then(resp => {
					// console.log('S : ', resp);
					resolve(resp)
				})
				.catch(err => {
					// console.log('E : ', err.response);
					reject(err)
				})
		})		
	},
	GETPROFILE: ({ commit, dispatch, state }) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			getProfile()
				.then(resp => {
					// console.log('S : ', resp);
					resolve(resp)
				})
				.catch(err => {
					// console.log('E : ', err.response);
					reject(err)
				})
		})		
	},
	UPLOADID: ({ commit, dispatch, state }, { data, progressEvent }) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			utilityFileUpload(data, progressEvent)
				.then(resp => {
					console.log('S : ', resp);
					// const token = resp.data.token
					// const user = resp.data.user
					// localStorage.setItem('token', token)
					// axios.defaults.headers.common['Authorization'] = token
					// commit('auth_success', token, user)
					resolve(resp)
				})
				.catch(err => {
					console.log('E : ', err.response);
					// commit('auth_error')
					// localStorage.removeItem('token')
					reject(err)
				})
		})		
	},
	UPLOADCERTIFICATE: ({ commit, dispatch, state }, { data, progressEvent }) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			utilityFileUpload(data, progressEvent)
				.then(resp => {
					console.log('S : ', resp);
					// const token = resp.data.token
					// const user = resp.data.user
					// localStorage.setItem('token', token)
					// axios.defaults.headers.common['Authorization'] = token
					// commit('auth_success', token, user)
					resolve(resp)
				})
				.catch(err => {
					console.log('E : ', err.response);
					// commit('auth_error')
					// localStorage.removeItem('token')
					reject(err)
				})
		})		
	},
	EXTRACTID: ({ commit, dispatch, state }, { data }) => {
		return new Promise((resolve, reject) => {
			// commit('auth_request')
			extractId(data)
				.then(resp => {
					console.log('S : ', resp);
					// const token = resp.data.token
					// const user = resp.data.user
					// localStorage.setItem('token', token)
					// axios.defaults.headers.common['Authorization'] = token
					// commit('auth_success', token, user)
					resolve(resp)
				})
				.catch(err => {
					console.log('E : ', err.response);
					// commit('auth_error')
					// localStorage.removeItem('token')
					reject(err)
				})
		})		
	},

	// ensure data for rendering given resource
	FETCH_RESOURCES_DATA: ({ commit, dispatch, state }, { resource }) => {
		const { activeResource, activeParams, activeResourceId, itemsPerPage, lists, route } = state;
		let params = {
			pageSize : itemsPerPage,
			pageNumber : 1,
			sort:'mbsdId',
			filter:{
				mbsdStatus : 0
			}
		};
		if (route.params&&route.params.page) params.pageNumber = Number(route.params.page);
		var resourceId = new Buffer(JSON.stringify({[resource]:params})).toString('base64');

		if (activeResourceId!=resourceId){
			console.log('FETCH_RESOURCES_DATA : ', activeResourceId, resourceId);
			commit('SET_ACTIVE_RESOURCE', { resource, params, resourceId })

			// var fetchingParams = {pageSize:itemsPerPage};
			// if (params){
			// 	fetchingParams = Object.assign({}, params, fetchingParams);
			// }

			// console.log('aaaaaaaaaaaaa', fetchParameters);
			// return fetchItemsByResource(resource, {params:fetchingParams})
			return fetchItemsByResource(resource, params)
				// .then(ids => commit('SET_LIST', { resource, ids }))
				.then(resourceOut => commit('SET_LISTS', { resource, resourceOut }))
				.then(() => dispatch('SHOW_ACTIVE_ITEMS'))
		} else {
			console.log('same resource skipping ... : ', resource, params)
			// return Promise.reject('Requesting same resource '+resource);
		}
		
	},

	FETCH_ADMIN_DATA: ({ commit, dispatch, state }, { resource }) => {
		const { activeResource, activeParams, activeResourceId, itemsPerPage, lists, route } = state;
		let params = {
			pageSize : itemsPerPage,
			pageNumber : 1,
			sort:'mbsdId',
			filter:{
				mbsdStatus : 0
			}
		};
		if (route.params&&route.params.page) params.pageNumber = Number(route.params.page);
		var resourceId = new Buffer(JSON.stringify({[resource]:params})).toString('base64');

		if (activeResourceId!=resourceId){
			console.log('FETCH_RESOURCES_DATA : ', activeResourceId, resourceId);
			commit('SET_ACTIVE_RESOURCE', { resource, params, resourceId })

			// var fetchingParams = {pageSize:itemsPerPage};
			// if (params){
			// 	fetchingParams = Object.assign({}, params, fetchingParams);
			// }

			// console.log('aaaaaaaaaaaaa', fetchParameters);
			// return fetchItemsByResource(resource, {params:fetchingParams})
			return fetchItemsByResource(resource, params)
				// .then(ids => commit('SET_LIST', { resource, ids }))
				.then(resourceOut => commit('SET_LISTS', { resource, resourceOut }))
				.then(() => dispatch('SHOW_ACTIVE_ITEMS'))
		} else {
			console.log('same resource skipping ... : ', resource, params)
			// return Promise.reject('Requesting same resource '+resource);
		}
		
	},

	FETCH_ASYNC_DATA: ({ commit, dispatch, state }, { resource, params }) => {
		console.log('Fetch async data here...');
		return false;
	},

	// ensure all active items are fetched
	SHOW_ACTIVE_ITEMS: ({ dispatch, getters }) => {
		return dispatch('FETCH_ITEMS', {
			resources : getters.getCurrentResources
		})
	},

	FETCH_ITEMS: ({ commit, state }, { resources }) => {
		console.log('FETCH_ITEMS Action: ', resources.data.length);
		// on the client, the store itself serves as a cache.
		// only fetch items that we do not already have, or has expired (3 minutes)
		// const now = Date.now()
		// ids = ids.filter(id => {
		// 	const item = state.items[id]
		// 	if (!item) {
		// 		return true
		// 	}
		// 	if (now - item.__lastUpdated > 1000 * 60 * 3) {
		// 		return true
		// 	}
		// 	return false
		// })
		// if (ids.length) {
		// 	return fetchItems(ids).then(items => commit('SET_ITEMS', { items }))
		// } else {
		// 	return Promise.resolve()
		// }
	},

	FETCH_USER: ({ commit, state }, { id }) => {
		return state.users[id]
			? Promise.resolve(state.users[id])
			: fetchUser(id).then(user => commit('SET_USER', { id, user }))
	},

	FETCH_EMAIL_LIST: ({ commit, state }, { resources }) => {
		console.log('FETCH_ITEMS Action: ');
		// on the client, the store itself serves as a cache.
		// only fetch items that we do not already have, or has expired (3 minutes)
		// const now = Date.now()
		// ids = ids.filter(id => {
		// 	const item = state.items[id]
		// 	if (!item) {
		// 		return true
		// 	}
		// 	if (now - item.__lastUpdated > 1000 * 60 * 3) {
		// 		return true
		// 	}
		// 	return false
		// })
		// if (ids.length) {
		// 	return fetchItems(ids).then(items => commit('SET_ITEMS', { items }))
		// } else {
		// 	return Promise.resolve()
		// }
	},
}



// WEBPACK FOOTER //
// src/store/actions.js